import {OnHoverTooltip} from '../../tooltip';
import {DetailedProps, join} from '../../utils';
import {forwardRef, useEffect, useRef, useState} from 'react';
import {fromEvent, debounceTime} from 'rxjs';
import styles from './styles.module.less';

export const OverflowSpan = forwardRef<HTMLSpanElement, DetailedProps<HTMLSpanElement>>((props, ref) => {
	const [isOverflow, setIsOverflow] = useState(false);
	const nameRef = useRef<HTMLSpanElement>();

	useEffect(() => {
		const isOverflowed = (): boolean => {
			if (nameRef.current) {
				const {clientWidth, scrollWidth} = nameRef.current;
				return clientWidth < scrollWidth;
			}
		};

		const sub = fromEvent(window, 'resize')
			.pipe(debounceTime(200))
			.subscribe(() => setIsOverflow(isOverflowed()));

		return () => sub.unsubscribe();
	}, []);

	return <OnHoverTooltip message={isOverflow && (props.children as any)}>
		<div className={join(styles.resizeableWrapper, isOverflow && styles.hovered, props.className)}>
			<span ref={nameRef} className={styles.resizeable}>{props.children}</span>
		</div>
	</OnHoverTooltip>;
});
